import * as React from 'react';
import b_ from 'b_';
import PercentView from 'components/PercentView';

import './index.scss';

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  title: string;
  children: number | null;
}

const b = b_.with('idea-top-card-fees-factoid');

export const Factoid: React.FC<Props> = ({ title, children, ...props }) => (
  <span className={b()} {...props}>
    <span className={b('title')} data-testid="title">
      {title}
    </span>
    <PercentView data-testid="value">{children}</PercentView>
  </span>
);
